export default __webpack_public_path__ + "57e885a5946e533ebd772668f05b8844.svg";